<template>
  <main>
    <div class="card-header sticky-top">
      <h5 class="card-title">Pesanan Saya</h5>
      <template>
        <button
          id="filterCollapse"
          :class="arrow === 0 ? 'btn btn-filter' : 'btn btn-filter active'"
          type="button"
          data-toggle="collapse"
          data-target="#collapseFilter"
          aria-expanded="false"
          aria-controls="collapseFilter"
          @click="arrowChanger"
        >
          <span style="color: #414141">
            Filters
            <i
              :class="
                arrow === 0 ? 'ml-2 fa fa-caret-down' : 'ml-2 fa fa-caret-up'
              "
              aria-hidden="true"
            ></i>
          </span>
        </button>
        <button @click="transactionRecap" class="btn btn-primary float-right">
          <i class="fa fa-file"></i> Download Rekap Transaksi
        </button>
        <div class="collapse show" id="collapseFilter">
          <div class="row">
            <div class="col-md-2">
              <!-- <select
                class="select-filter"
                name="limitFilter"
                v-model="limitFilter"
                id="limitFilter"
              >
                <option value="" selected disabled>Show</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select> -->
              <vue-select
                class="ml-3"
                :options="limitData"
                v-model="limitFilter"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Filter Status Pesanan..."
                :clearable="clearable"
              />
              <div class="select-filter-icon">
                <i class="fa fa-th-list" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-md-6">
              <input
                class="input-filter-custom form-control-danger"
                v-model="searchInvoice"
                id="nameFilter"
                name="nameFilter"
                type="text"
                placeholder=""
              />

              <div class="input-filter-icon">
                <i class="fa fa-search mr-2"></i
                ><span style="font-size: 12px">Kode Pesanan</span>
              </div>
              <div class="col" style="margin-top: -30px; margin-left: 50px">
                <a
                  @click="toDetail()"
                  class="btn btn-sm btn-primary text-white float-right"
                  style="
                    margin: -5px 35px 10px 10px;
                    padding: 9px 10px 9px 10px;
                  "
                  ><i class="fa fa-send mt-1" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            <div class="col-md-4">
              <!-- <select
                class="select-filter"
                name="statusFilter"
                id="statusFilter"
                v-model="statusFilter">
                <option
                  :selected="stat.isSelected"
                  :value="stat.value"
                  v-for="(stat, index) in status"
                  :key="index">{{ stat.name }} </option>
              </select> -->
              <vue-select
                class="ml-3"
                :options="status"
                v-model="statusFilter"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Filter Status Pesanan..."
                :clearable="clearable"
              />
              <div class="select-filter-icon">
                <i class="fa fa-filter" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="card-body">
      <!-- <router-link :to="{ name: 'create' }" class="btn btn-primary"
              >Create new article</router-link
            > -->
      <div class="col-md-2 mb-4 pull-right" style="margin-left: 0%">
        <input
          class="input-filter pull-right"
          id="nameFilter"
          v-model="searchInvoice"
          name="nameFilter"
          type="text"
          placeholder="Search..."
        />
        <div class="input-filter-icon">
          <i class="fa fa-search mr-2"></i><span style="font-size: 12px"></span>
        </div>
      </div>
      <div class="pull-left resetFilter">
        <button
          class="btn btn-secondary btn-sm btn-circle y pull-right"
          id="resetFilter"
          @click="resetFilter"
        >
          <i
            id="resetIcon"
            class="now-ui-icons arrows-1_refresh-69"
            aria-hidden="true"
            style="font-size: 15px"
          ></i>
        </button>
      </div>
      <TableLoader />
      <div class="table-responsive">
        <!-- <Loading /> -->
        <table
          id="table_order"
          class="table table-condensed text-center table-hover"
          width="100%"
        >
          <thead class="">
            <tr class="table-condensed text-sm-center">
              <th
                id="filterSort"
                class="filterSort"
                v-for="col in column"
                @click="col.value == '' ? sort('') : sort(col.value)"
                :key="col.name"
                style="cursor: pointer"
              >
                {{ col.name }}
                <template v-if="col.isOrder">
                  <template v-if="col.order === ''">
                    <i class="up-icon" />
                    <i class="down-icon" />
                  </template>
                  <template v-else>
                    <i
                      :class="[col.order === 'asc' ? 'up-icon' : 'down-icon']"
                    />
                  </template>
                </template>
                <!-- <i v-if="col.isOrder" style="font-size:9px"
                    :class="[col.order === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down']"/> -->
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="orders == ''">
              <td class="table-secondary" :colspan="column.length">
                No Data Found
              </td>
            </tr>
            <tr
              style="cursor:pointer;"
              @click="eventDetail(order.id)"
              v-for="(order, index) in orders"
              :key="index"
            >
              <td class="text-center">{{ order.no }}</td>
              <!-- <td>{{ }}</td> -->
              <td>
                <div
                  class="font-weight-bold text-center"
                  style="color: #495057"
                >
                  {{ order.invoice.slice(-6) }}
                </div>
              </td>
              <td>{{ order.customerName }}</td>
              <td>{{ order.npsn }}</td>
              <td>{{ order.schoolName }}</td>
              <td>{{ order.schoolCity }}</td>
              <td v-html="order.status"></td>
              <td>{{ order.total }}</td>
              <td>{{ order.date }}</td>
              <td>{{ order.paymentDue }}</td>
              <td>
                <router-link
                  :to="'/pesanan/detail/' + order.id"
                  class="
                    btn btn-outline-default btn-success
                    bg-transparent
                    btn-sm
                  "
                  style="width: 20px; border: 0px"
                >
                  <i class="fa fa-pen" style="font-size: 17px"> </i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col">
          <p class="text-muted mt-1 ml-4 pull-left">
            Showing {{ ordersPagination.from }} to {{ ordersPagination.to }} of
            {{ ordersPagination.total }} entries
          </p>
        </div>
        <div class="col">
          <pagination
            :data="ordersPagination"
            @pagination-change-page="getResult"
            :align="align"
            :limit="limit"
            :showDisabled="showDisabled"
          ></pagination>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TableLoader from "/src/components/loader/TableLoader.vue";
// import CryptoJS from "crypto-js";
import axios from "axios";
import $ from "jquery";
import { sleeper } from "/src/utils/sleeper.js";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import VueSelect from "vue-select";

export default {
  components: {
    TableLoader,
    VueSelect,
  },
  props: {
    transactionRecap: { type: Function },
  },
  data() {
    return {
      limitData: [
        { name: 5, value: 5 },
        { name: 10, value: 10 },
        { name: 25, value: 25 },
        { name: 50, value: 50 },
        { name: 100, value: 100 },
      ],
      orders: {},
      ordersPagination: {
        from: 0,
        to: 0,
        total: 0,
      },
      column: {},
      status: [],
      clearable: false,
      limit: 3,
      limitFilter: 10,
      statusFilter: "",
      searchInvoice: "",
      currentSort: "m.date_added",
      currentSortDir: "desc",
      // size: "default",
      align: "right",
      showDisabled: true,
      arrow: 0,
    };
  },
  watch: {
    limitFilter() {
      this.getResult(1);
    },
    statusFilter() {
      // let encrypted = CryptoJS.AES.encrypt(this.statusFilter, "1c1ass").toString();
      // localStorage.setItem('recentStatusFilterOrder', encrypted)
      this.getResult(1);
    },
    currentSortDir() {
      this.getResult(1);
    },
    searchInvoice() {
      this.getResult(1);
    },
  },
  created() {
    this.getResult(1);
  },
  methods: {
    eventDetail(id) {
      this.$router.push(`/pesanan/detail/${id}`);
    },
    arrowChanger() {
      if (this.arrow === 0) {
        this.arrow = 1;
        $("#filterCollapse").addClass("active");
      } else {
        this.arrow = 0;
        $("#filterCollapse").addClass("");
      }
    },
    getResult(page) {
      $("table").addClass("table-loading");
      const params = `?page=${page}&limit=${this.limitFilter}&filter_status=${
        this.statusFilter
      }&sort=${this.currentSort + "-" + this.currentSortDir}&search=${
        this.searchInvoice
      }`;
      let orderUrl = `seller/order${params}`;
      axios
        .get(orderUrl)
        .then(sleeper(0))
        .then((response) => {
          // console.log(response)
          return response.data;
        })
        .then((data) => {
          $("table").removeClass("table-loading");
          $("table").removeClass("table-loader");
          $("#table-placeholder").hide();
          const orders = data.data.items;
          this.column = data.data.column;
          this.status = data.data.filters.items;
          // console.log(data.data.filters.items)
          this.orders = orders;
          this.ordersPagination = {
            current_page: page,
            data: orders,
            from: data.data.from,
            last_page: data.data.lastPage,
            next_page_url: data.data.nextPage,
            per_page: data.data.perPage,
            prev_page_url: data.data.prevPageUrl,
            to: data.data.to,
            total: data.data.total,
          };
          Vue.component("vue-select", VueSelect);
        });
    },
    resetFilter() {
      this.getResult(1);
      Object.assign(
        (this.currentPage = 1),
        (this.limitFilter = 10),
        (this.statusFilter = ""),
        (this.searchInvoice = ""),
        (this.currentSort = "m.date_added"),
        (this.currentSortDir = "desc"),
        (this.searchGlobal = "")
      );
      $("#resetIcon").addClass("spin");
      setTimeout(function() {
        $("#resetIcon").removeClass("spin");
      }, 500);
    },
    toDetail() {
      // this.$swal.fire('Oops...', 'Something went wrong!', 'error');
      let timerInterval;
      if (this.searchInvoice === "") {
        this.$swal.fire({
          title: `<span style='font-size:17px'>Perhatian</span>`,
          text: `Masukan Nomor Invoice yang ingin dicari`,
          icon: "warning",
          showConfirmButton: true,
          confirmButtonColor: "#556ee6",
        });
      } else {
        this.$swal
          .fire({
            title: "Redirect...",
            // imageUrl: 'https://media.giphy.com/media/KG4PMQ0jyimywxNt8i/source.gif',
            html: `Menuju ke pesanan dengan invoice <b>${this.orders[0].invoice}</b>  `,
            timer: 1000,
            timerProgressBar: false,
            width: 400,
            padding: "2em",
            // heightAuto: true,
            didOpen: () => {
              this.$swal.showLoading();
              timerInterval = setInterval(() => {
                const content = this.$swal.getContent();
                if (content) {
                  const b = content.querySelector("b");
                  if (b) {
                    b.textContent = this.$swal.getTimerLeft();
                  }
                }
              }, 1000);
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.$router.push({
                path: `/pesanan/detail/${this.orders[0].id}`,
              });
            },
          })
          .then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === this.$swal.DismissReason.timer) {
              this.$router.push({
                path: `/pesanan/detail/${this.orders[0].id}`,
              });
            }
          });
      }
    },
    sort(colValue) {
      // if you click the same label twice
      $("#filterSort").trigger("click");
      if (this.currentSort === colValue) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        $("#filterSort").trigger("click");
        this.currentSort = colValue;
        //  this.currentSortDir= '';
        // console.log( 'sekarang lagi col: '+col );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "vue-select/src/scss/vue-select.scss";
</style>
<style>
.badge-dark {
  font-size: 11px !important;
  color: #343a40 !important;
  background-color: rgba(52, 58, 64, 0.25) !important;
}
.vs__dropdown-toggle {
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: transparent;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom: 0.3px solid #818181;
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 1px;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;

  border-radius: 0px;
}
.modal-content {
  background-color: rgb(245, 245, 245);
}
.up-icon::before {
  content: "\2191";
}
.down-icon::after {
  content: "\2193";
}
</style>
<style scoped>
.select-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png)
    no-repeat right #ddd;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #818181;
  color: #464545;
  padding: 0px 0px 0px 30px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
} /* For IE <= 11 */
.select-filter::-ms-expand {
  display: none;
}

select option {
  /* margin: 40px; */
  background-color: transparent;
  color: #414141;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); */
}

.input-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 0.3px solid #818181;
  /* color: #464545; */
  padding: 0px 0px 0px 40px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

.input-filter-custom {
  width: 100%;
  height: 29.5px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 0.3px solid #818181;
  /* color: #464545; */
  padding: 0px 0px 0px 130px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

.input-filter::-ms-expand {
  display: none;
}

.input-filter-icon {
  position: absolute;
  top: 5px;
  left: 20px;
  width: 100%;
  /* height: 36px; */
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.input-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter-icon {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 30px;
  height: 36px;
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.select-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter:hover ~ .select-filter-icon,
.select-filter:focus ~ .select-filter-icon {
  background-color: white;
  /* border-color: #464545; */
}
</style>
